<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-12-01 20:57:00
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-08-25 11:23:59
-->
<template>
  <el-dialog
    ref="elDialog"
    v-dialogDrag
    :title="
      operType === 'edit'
        ? $t('org.editOrg')
        : operType === 'add'
          ? $t('org.createOrg')
          : operType === 'details'
            ? $t('org.details')
            : $t('org.createOrg')
    "
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="self-dialog-form"
    width="50%"
  >
    <div class="custom-theme">
      <el-form
        ref="formInfo"
        :model="formInfo"
        :rules="rules"
        label-position="top"
        :hide-required-asterisk="hideStar"
        class="demo-formInfo clearfix custom-theme"
      >
        <el-row :gutter="24">
          <!-- 部门名称 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.orgName')" prop="orgName">
              <el-input
                v-model="formInfo.orgName"
                :disabled="operType === 'details'"
                :placeholder="operType !== 'details' ? $t('common.pleaseEnter') : ''"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 上级部门 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.parentOrg')" prop="parentId">
              <TreeSelect
                v-model="formInfo.parentId"
                :multiple="false"
                :disabled="operType === 'details'"
                :placeholder="$t('common.pleaseChoose')"
                :tree-data="orgData"
                :show-node="false"
                :show-search="true"
                @change="handleCheckChange"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- 部门编码 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.orgCode')" prop="orgCode">
              <el-input
                v-model="formInfo.orgCode"
                :disabled="operType === 'details'"
                :placeholder="operType !== 'details' ? $t('common.pleaseEnter') : ''"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 排序 -->
          <el-col :span="12">
            <el-form-item :label="$t('user.sort')" prop="sort">
              <el-input-number
                v-model="formInfo.sort"
                :disabled="operType === 'details'"
                :precision="0"
                controls-position="right"
                :min="0"
                :placeholder="operType !== 'details' ? $t('org.pleaseEnterSort') : ''"
                max-length="10"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- 部门简称 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.orgShortName')" prop="orgShortName">
              <el-input
                v-model="formInfo.orgShortName"
                :disabled="operType === 'details'"
                :placeholder="operType !== 'details' ? $t('common.pleaseEnter') : ''"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 是否有效 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.isEffect')" prop="effect">
              <el-radio-group
                ref="radioGroup"
                v-model="formInfo.effect"
                :disabled="operType === 'details'"
              >
                <el-radio :label="true">有效</el-radio>
                <el-radio :label="false">无效</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- 地点 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.address')" prop="address">
              <el-input
                v-model="formInfo.address"
                :disabled="operType === 'details'"
                type="textarea"
                :rows="4"
                :placeholder="
                  operType !== 'details'
                    ? `${$t('org.pleaseEnterContent')}(${$t('common.wordCountLimit', [
                      $getInputMaxLimitConst('limit100')
                    ])})`
                    : ''
                "
                :maxlength="$getInputMaxLimitConst('limit100')"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 描述 -->
          <el-col :span="12">
            <el-form-item :label="$t('org.remarks')" prop="remark">
              <el-input
                v-model="formInfo.remark"
                :disabled="operType === 'details'"
                type="textarea"
                :rows="4"
                :placeholder="
                  operType !== 'details'
                    ? `${$t('org.pleaseEnterContent')}(${$t('common.wordCountLimit', [
                      $getInputMaxLimitConst('limit100')
                    ])})`
                    : ''
                "
                :maxlength="$getInputMaxLimitConst('limit100')"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="operType === 'details'" type="primary" @click="closeModel">
        {{ $t('common.closeTxt') }}
      </el-button>
      <el-button v-if="operType !== 'details'" plain @click="closeModel">
        {{ $t('public.cancel') }}
      </el-button>
      <el-button
        v-if="operType !== 'details'"
        :loading="infoLoading"
        type="primary"
        @click="submitForm('formInfo')"
      >
        {{ $t('public.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import orgApi from "@/api/org/org";
import { mapGetters } from "vuex";
export default {
  name: "DepartManageAdd",
  components: {},

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      disabled: false,
      infoLoading: false,
      formInfo: {
        effect: true,
        sort: 0,
        parentId: "",
        parentName: "",
        orgName: "",
        orgCode: "",
        address: "",
        remark: ""
      },
      rules: {
        // 部门名称
        orgName: [
          {
            required: true,
            message: `${this.$t("common.pleaseEnter")}${this.$t("org.orgName")}`,
            trigger: ["blur"]
          }
        ],
        // 部门编码
        orgCode: [
          {
            required: true,
            message: `${this.$t("common.pleaseEnter")}${this.$t("org.orgCode")}`,
            trigger: ["blur"]
          }
        ],
        // 上级部门
        parentId: [
          {
            required: true,
            message: `${this.$t("common.pleaseChoose")}${this.$t("org.parentOrg")}`,
            trigger: ["blur", "change"]
          }
        ]
      },
      orgData: [],
      hideStar: false
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    operType() {
      return this.propData.pageType;
    },
    ...mapGetters(["tenantId"])
  },
  created() {
    this.getOrgTree();
    if (this.operType !== "add") {
      this.getDetailsById(this.propData.id);
      if (this.operType === "details") {
        this.hideStar = true;
      }
    } else {
      // 新增时将组织赋值上去
      this.formInfo.effect = true;
      this.formInfo.sort = "0";
      this.formInfo.parentId = this.propData.parentId;
      this.formInfo.parentName = this.propData.parentName;
    }
  },
  methods: {
    // 单选树型结构选项框被点击发生改变
    handleCheckChange(data) {
      if (data && data.length) {
        this.$set(this.formInfo, "parentName", data[0].label);
      }
    },
    getDetailsById(id) {
      orgApi.getDetailsById(id).then(res => {
        if (res.success) {
          this.formInfo = { ...res.data };
        }
      });
    },
    // 获取组织列表
    getOrgTree() {
      const params = {
        parseToTree: true
      };
      orgApi.getOrgList(this.tenantId, params).then(res => {
        const { data } = res || {};
        if (data) {
          this.orgData =
            this.orgTraverseTree([data], "orgName", "id", { id: this.formInfo.id }) || [];
        }
      });
    },
    // 遍历组织树
    orgTraverseTree(data, name, id, selfobj) {
      data.forEach(val => {
        val.label = val[name];
        val.value = val[id];
        if (val.value === selfobj.id || selfobj.disabled) {
          val.disabled = true;
        }
        if (val.children) {
          this.orgTraverseTree(val.children, name, id, {
            id: selfobj.id,
            disabled: val.disabled || false
          });
        }
      });
      return data;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.infoLoading = true;
          if (this.formInfo.id) {
            // 编辑
            this.editForm();
          } else {
            // 新增
            this.addForm();
          }
        } else {
          return false;
        }
      });
    },
    closeModel() {
      this.dialogVisible = false;
    },
    editForm() {
      orgApi
        .editOrg(this.formInfo)
        .then(res => {
          this.infoLoading = false;
          this.$message.closeAll();
          this.$message.success(this.$t("common.editSuccess"));
          this.dialogVisible = false;
          this.$emit("success");
        })
        .catch(() => {
          this.infoLoading = false;
        });
    },
    addForm() {
      orgApi
        .addOrg(this.formInfo)
        .then(res => {
          this.infoLoading = false;
          this.$message.closeAll();
          this.$message.success(this.$t("common.addSuccess"));
          this.dialogVisible = false;
          this.$emit("success");
        })
        .catch(() => {
          this.infoLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss"></style>
